// app/frontend/lib/api.js
// Zentraler HTTP-Client für alle Svelte → Rails API-Calls
// Inkludiert automatisch den CSRF-Token aus dem Rails Meta-Tag
//
// Alle Helfer hier geben die rohe Response zurück und werfen NICHT bei
// Statuscodes >= 400. Das ist Absicht: die Formulare dieses Projekts brauchen
// den Body auch (und gerade) im Fehlerfall — 422 trägt die Feldfehler, 429 die
// Drosselungsmeldung (RATELIMIT-001). Ein Wrapper, der bei !ok wirft, müsste
// beides über ein Error-Objekt zurückschmuggeln.

import { csrfToken } from './csrf.js'

/**
 * JSON-POST — das Muster der Auth-Inseln (LoginForm, RegistrationForm).
 * Gibt die rohe Response zurück; der Aufrufer entscheidet, was ein 422 oder
 * ein 429 für ihn bedeutet.
 */
export async function postJson(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  })
}

/**
 * Multipart/FormData POST — für Svelte Islands die Daten an Rails senden.
 * Kein Content-Type Header — Browser setzt Boundary automatisch.
 */
export async function postForm(url, formData) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: formData,
  })
  return response
}

/**
 * Multipart/FormData PATCH — für Svelte Islands im Edit-Mode.
 */
export async function patchForm(url, formData) {
  const response = await fetch(url, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
    body: formData,
  })
  return response
}

/**
 * Einfacher GET — für Svelte Islands (z.B. check_slug).
 * Gibt Response-Objekt zurück (kein automatisches JSON-Parsing).
 */
export async function get(url) {
  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    credentials: 'same-origin',
  })
  return response
}
